import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	Modal, Box, Stack, Checkbox, FormGroup, Button, ButtonGroup, IconButton,
	Tooltip, Accordion, AccordionSummary, Typography, AccordionDetails, Menu, MenuItem,
	FormControl, InputLabel, Select
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Form } from 'react-bootstrap';
import BSButton from 'react-bootstrap/Button'
import Component from '../Component'
import EntityApi from "../../api/entity"
import { BsPencilSquare } from 'react-icons/bs';
import { BsInfoCircle } from 'react-icons/bs';
import AddIcon from '@mui/icons-material/Add';
import './style.css'
import { styleNotFull, styleFull } from '../../store/utils/entityUtils';
import colors from 'theme/colors';

const typeLabels = {
	all: 'Todos',
	table: 'Table',
	view: 'View',
	procedure: 'Procedure'
};

const EntityModal = ({ open, onClose, style, autoSelect, onSelectEntity, entityToEdit, filterType = 'all' }) => {

	const [inputs, setInputs] = useState({});
	const [entities, setEntities] = useState([]);
	const [filteredEntities, setFilteredEntities] = useState([]);
	const [selectedEntity, setSelectedEntity] = useState({});
	const [columns, setColumns] = useState([]);
	const [filteredColumns, setFilteredColumns] = useState([]);
	const [selectedColumns, setSelectedColumns] = useState([]);
	const [isAllExpanded, setIsAllExpanded] = useState(false);
	const [isFullScreen, setIsFullScreen] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const normalizedFilterType = (filterType || 'all').toLowerCase();
	const isTypeLocked = normalizedFilterType !== 'all';
	const [entityTypeFilter, setEntityTypeFilter] = useState(normalizedFilterType);

	const navigate = useNavigate();

	// Detecta quando um entityToEdit é passado e navega para a rota apropriada
	useEffect(() => {
		if (entityToEdit && open) {
			const config = entityToEdit.config;
			const typeView = config?.typeView;
			const isView = config?.isView;
			const isProcedure = config?.isProcedure;
			const isTable = !isView && !isProcedure;
			const entityName = entityToEdit.entity;

			if (isProcedure) {
				// Navega para edição de Procedure
				onClose([]);
				navigate(`/entity/edit/procedure/${entityName}`);
			} else if (isView && typeView === 'Command') {
				// Navega para edição de View Command
				onClose([]);
				navigate(`/entity/edit/view-command/${entityName}`);
			} else if (isView) {
				// Navega para edição de View normal
				onClose([]);
				navigate(`/entity/edit/view/${entityName}`);
			} else if (isTable) {
				// Navega para edição de Table
				onClose([]);
				navigate(`/entity/edit/table/${entityName}`);
			}
		}
	}, [entityToEdit, open, navigate, onClose]);

	const handleSubmitViewModal = (event) => {
		event.preventDefault();
		let cols = columns.filter(col => selectedColumns.includes(col.name))
		onClose(cols);
	};

	const searchEntities = (event) => {
		const name = event.target.name;
		const value = event.target.value;
		setInputs(values => ({ ...values, [name]: value }))

		applyFilters(value, entityTypeFilter);
	}

	const applyFilters = (searchText, typeFilter, baseList = entities) => {
		let filtered = baseList.filter((entity) => entity.entity
			?.toLowerCase().includes(searchText.toLowerCase())
		);

		// Aplicar filtro de tipo
		if (typeFilter !== 'all') {
			filtered = filtered.filter((entity) => {
				const config = entity.config;
				if (typeFilter === 'table') {
					return !config?.isView && !config?.isProcedure;
				} else if (typeFilter === 'view') {
					return config?.isView === true;
				} else if (typeFilter === 'procedure') {
					return config?.isProcedure === true;
				}
				return true;
			});
		}

		setFilteredEntities(filtered.sort((a, b) => a.entity.localeCompare(b.entity)));
	}

	const handleTypeFilterChange = (event) => {
		const newType = event.target.value;
		setEntityTypeFilter(newType);
		applyFilters(inputs.entity || '', newType);
	}

	const selectEntity = (entity) => {
		// console.log(entity)
		// console.log(entity.config?.columns)
		setSelectedEntity(entity)
		setColumns(entity.config?.columns || [])
		setFilteredColumns(entity.config?.columns || [])
		if (autoSelect && onSelectEntity) {
			onSelectEntity(entity);
			onClose([]);
		}
	}

	const filterColumns = (event) => {
		const name = event.target.name;
		const value = event.target.value;
		setInputs(values => ({ ...values, [name]: value }))

		setFilteredColumns(columns.filter((field) => field?.name?.toLowerCase().includes(value.toLowerCase())))
	}

	const checkColumn = (column) => {
		setSelectedColumns((prev) =>
			prev.includes(column.name) ? prev.filter((value) => value !== column.name) : [...prev, column.name]
		);
	}

	const expandAll = () => {
		setIsAllExpanded(!isAllExpanded)
		if (!isAllExpanded) {
			setFilteredColumns(filteredColumns.map((column) => {
				return { ...column, expanded: true }
			}))
		} else {
			setFilteredColumns(filteredColumns.map((column) => {
				return { ...column, expanded: false }
			}))
		}
	}

	const loadEntities = (typeToApply = entityTypeFilter) => {
		EntityApi.getAll().then((res) => {
			const list = res.data || [];
			setEntities(list)
			applyFilters(inputs.entity || '', typeToApply, list)
		}).catch((err) => {
			console.log(err)
		})
	};

	useEffect(() => {
		if (!!open) {
			setInputs({})
			setEntityTypeFilter(normalizedFilterType);
			loadEntities(normalizedFilterType);
		}

		setColumns([])
		setFilteredColumns([])
		setSelectedColumns([])
		setSelectedEntity({})
	}, [open, normalizedFilterType])

	return (
		<>
			<Modal open={!!open} onClose={onClose}>
				<Box
					className="modalBox"
					sx={isFullScreen ? styleFull : styleNotFull}
					style={style}
				>
					<Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} flexShrink={0}>
						<Stack direction="row" alignItems="center" spacing={1}>
							<AddIcon />
							<Typography variant="h5">Adicionar Componente</Typography>
						</Stack>

								<Tooltip title={isFullScreen ? "Sair do Full Screen" : "Entrar em Full Screen"}>
							<IconButton
								onClick={() => setIsFullScreen(!isFullScreen)}
								size="large"
								aria-label="toggle fullscreen"
							>
										{isFullScreen ? <CloseFullscreenIcon sx={{ color: colors.primary }} /> : <OpenInNewIcon sx={{ color: colors.primary }} />}
							</IconButton>
						</Tooltip>
					</Stack>

					<Form className="row g-3" onSubmit={handleSubmitViewModal} style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
						<Stack spacing={2} className="col-md-5" sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
							<FormControl size="small" fullWidth>
								<InputLabel id="entity-type-filter-label">Tipo</InputLabel>
								<Select
									labelId="entity-type-filter-label"
									id="entity-type-filter"
									value={entityTypeFilter}
									label="Tipo"
									onChange={handleTypeFilterChange}
									disabled={isTypeLocked}
								>
									{(isTypeLocked ? [normalizedFilterType] : ['all', 'table', 'view', 'procedure']).map((value) => (
										<MenuItem key={value} value={value}>{typeLabels[value] || value}</MenuItem>
									))}
								</Select>
							</FormControl>

							<Component
								data={{
									type: "text",
									name: "Entidade",
									nameForm: "entity",
									class: "col-md-12",
								}}
								inputs={inputs}
								handleChange={searchEntities}
								entity="views"
							/>

							<Stack spacing={1} sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
								<FormGroup className="m0">
									<ButtonGroup orientation="vertical" variant="text" fullWidth >
										{filteredEntities.map((entity) => {
											//  console.log("entidade ", JSON.stringify(entity, null, 2))
											return (
												<Button
													key={entity.entity}
													onClick={() => selectEntity(entity)}
													variant={selectedEntity.entity === entity.entity ? "contained" : "text"}
													sx={{ textTransform: "none" }}
													style={{
														position: 'relative',
														textTransform: "none",
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														width: '100%',
														paddingRight: '32px'
													}}
												>
													<span>
														{entity.config?.description
															? `${entity.entity} - ${entity.config.description}`
															: entity.entity}
													</span>

													{selectedEntity.entity === entity.entity && (														
														<>
															<Tooltip title={"Ver dados detalhados da entidade"} >
																<span
																	style={{
																		position: 'absolute',
																		right: '40px',
																		top: '50%',
																		transform: 'translateY(-50%)',
																		cursor: 'pointer'
																	}}
																	onClick={(event) => {
																		event.stopPropagation();
																		navigate(`/detailByEntity/${selectedEntity.entity}`);
																		onClose([])
																	}}
																>
																	<BsInfoCircle/>
																</span>
															</Tooltip>
															<Tooltip title={selectedEntity?.config?.isProcedure ? "Editar Procedure" : (selectedEntity?.config?.isView ? "Editar View" : "Editar Tabela")} >
																<span
																	style={{
																		position: 'absolute',
																		right: '8px',
																		top: '50%',
																		transform: 'translateY(-50%)',
																		cursor: 'pointer'
																	}}
															onClick={(event) => {
																event.stopPropagation();
																const config = selectedEntity?.config;
																const isView = config?.isView;
																const isProcedure = config?.isProcedure;
																const typeView = config?.typeView;
																const entityName = selectedEntity?.entity;
																
																onClose([]);
																
																if (isProcedure) {
																	// Procedure
																	navigate(`/entity/edit/procedure/${entityName}`);
																} else if (isView && typeView === 'Command') {
																	// View com comando SQL
																	navigate(`/entity/edit/view-command/${entityName}`);
																} else if (isView) {
																	// View normal
																	navigate(`/entity/edit/view/${entityName}`);
																} else {
																	// Tabela
																	navigate(`/entity/edit/table/${entityName}`);
																}
															}}
																>
																	<BsPencilSquare />
																</span>
															</Tooltip>
														</>


													)}
												</Button>
											)
										}
										)}
									</ButtonGroup>
								</FormGroup>
							</Stack>
						</Stack>

						<Stack spacing={2} className="col-md-7" sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
							<Stack direction="row" spacing={1} className="col-md-12">
								<Component
									data={{
										type: "text",
										name: "Campo",
										nameForm: "column",
										class: "col-md-10",
									}}
									inputs={inputs}
									handleChange={filterColumns}
								/>
								<Tooltip title={isAllExpanded ? "Fechar todos" : "Expandir todos"} placement="bottom">
									<IconButton
										aria-label="expand"
										size="large"
										onClick={() => expandAll()}
										className="expandIcon"
									>
										{isAllExpanded ? <CloseFullscreenIcon fontSize="inherit" /> : <OpenInFullIcon fontSize="inherit" />}
									</IconButton>
								</Tooltip>
								{/* <Tooltip title="Criar Nova Entidade." placement="bottom"> */}
								<IconButton
									aria-label="create-entity"
									size="large"
									className="expandIcon"
									onClick={(event) => setAnchorEl(event.currentTarget)}
								>
									<AddIcon
										fontSize="inherit"
										sx={{
											backgroundColor: '#4CAF50',
											color: 'white',
											borderRadius: '8px',
											'&:hover': {
												backgroundColor: '#45A049',
											},
										}}
									/>
								</IconButton>
								<Menu
									anchorEl={anchorEl}
									open={Boolean(anchorEl)}
									onClose={() => setAnchorEl(null)}
								>
									<MenuItem
										onClick={() => {
											onClose([]);
											navigate('/entity/new/table');
											setAnchorEl(null);
										}}
									>
										Tabela
									</MenuItem>
									<MenuItem
										onClick={() => {
											onClose([]);
											navigate('/entity/new/view');
											setAnchorEl(null);
										}}
									>
										View
									</MenuItem>
									<MenuItem
										onClick={() => {
											onClose([]);
											navigate('/entity/new/view-command');
											setAnchorEl(null);
										}}
									>
										View Command
									</MenuItem>
									<MenuItem
										onClick={() => {
											onClose([]);
											navigate('/entity/new/procedure');
											setAnchorEl(null);
										}}
									>
										Procedure
									</MenuItem>
								</Menu>
								{/* </Tooltip> */}
							</Stack>

							<Stack spacing={1} sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
								<FormGroup className="m0">
									{filteredColumns?.map((column) => {
										// console.log("campo", JSON.stringify(column, null, 2))
										return (
											<Accordion key={column.name} className="m0" expanded={column.expanded || false} onChange={() => {
												setFilteredColumns(filteredColumns.map((col) => {
													if (col.name === column.name) {
														return { ...col, expanded: !col.expanded }
													}
													return col
												}
												))
											}}>
												<AccordionSummary
													expandIcon={<ExpandMoreIcon />}
												>
													<Checkbox
														value={column.name}
														checked={selectedColumns.includes(column.name)}
														onChange={() => { checkColumn(column) }}
														sx={{ marginRight: 1 }}
													/>
													<Typography alignContent="center">{column.name}</Typography>
												</AccordionSummary>
												<AccordionDetails>
													<ul>
														<li>Tipo: {column.type}</li>
														<li>Descrição: {column.description}</li>
														<li>Obrigatório: {column.required ? "true" : "false"}</li>
														<li>Único: {column.rules?.unique ? "true" : "false"}</li>
														{column.rules?.regex && <li>Máscara: {column.rules?.regex}</li>}
														<li>Validação: {column.rules?.validation}</li>
													</ul>
												</AccordionDetails>
											</Accordion>
										)
									}
									)}
								</FormGroup>
							</Stack>
						</Stack>

						<div className="col-md-12 submitButton" style={{ marginTop: 'auto', paddingTop: '16px', flexShrink: 0 }}>
							<BSButton type="button" className="btn btn-primary me-1" variant="danger" onClick={() => onClose([])}>Cancelar</BSButton>
							<BSButton type="submit" className="btn btn-primary">Aplicar</BSButton>
						</div>
					</Form>
				</Box>
			</Modal>
		</>
	)
}

export default EntityModal;